import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map, Subscription } from 'rxjs';
import { AuthService } from '../app/guards/service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class FreelancerDataService {
  API_SERVER = environment.apiUrl;
  API_SERVER_SECURED = `${environment.apiUrl}/secured`;

  
  private _authSub?: Subscription;

  constructor(
    private httpClient: HttpClient,
    private toastrService: ToastrService,
    private auth: AuthService,
  ) {
    
    this._authSub = this.auth.authChanged$.subscribe(() => {
     
    });
  }

  // ---------- Public (no auth) ----------
  getconsultantRegistration(cParams = {}): Observable<any> {
    const params = this.getHttpParams(cParams);
    return this.httpClient
      .get(`${this.API_SERVER}/registration`, { params: params.set('locale', 'ms-MY') })
      .pipe(map((res: any) => this.extractData(res)));
  }

  registerUser(data: any): Observable<any> {
    return this.httpClient
      .post(`${this.API_SERVER}/registration`, data)
      .pipe(map((res: any) => this.extractData(res)));
  }

  registerCommunityUser(data: any): Observable<any> {
    return this.httpClient
      .post(`${this.API_SERVER}/registration-communityUser`, data)
      .pipe(map((res: any) => this.extractData(res)));
  }

  sendOTP(data: any): Observable<any> {
    return this.httpClient
      .post(`${this.API_SERVER}/send-otp`, data)
      .pipe(map((res: any) => this.extractData(res)));
  }

  resetPassword(data: any): Observable<any> {
    return this.httpClient
      .post(`${this.API_SERVER}/reset-password`, data)
      .pipe(map((res: any) => this.extractData(res)));
  }

  // ---------- Secured (auth) ----------
  getFreelancerProfile(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/personal-info`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  getUserCommunities(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/communities`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  getFreelancerAvatar(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/avatar`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  uploadAvatar(fd: FormData, customHeaderValue?: any): Observable<any> {
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .post(`${this.API_SERVER_SECURED}/user/avatar`, fd, { headers })
      .pipe(map((res: any) => this.extractData(res)));
  }

  getFreelancerDesignations(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/designations`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  getFreelancerResume(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/resume`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  getFreelancerSkills(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/skills`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  displayResume(cParams = {}, _resume_name: any): Observable<any> {
    const params = this.getHttpParams(cParams);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/recruiter/jobseekers/resume`, {
        params,
        responseType: 'arraybuffer',
      })
      .pipe(map((byteArray: any) => byteArray));
  }

  uploadResume(fd: FormData, customHeaderValue?: any): Observable<any> {
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .post(`${this.API_SERVER_SECURED}/user/resume`, fd, { headers })
      .pipe(map((res: any) => this.extractData(res)));
  }

  updateUserActive(customHeaderValue?: any): Observable<any> {
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient.post(`${this.API_SERVER_SECURED}/user/active`, {}, { headers });
  }

  getFreelancerProfileNotificationSettings(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/notification-settings`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  updateFreelancerEmailNotificationSettings(data: any, customHeaderValue?: any): Observable<any> {
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .patch(`${this.API_SERVER_SECURED}/user/notification-settings`, data, { headers })
      .pipe(map((res: any) => this.extractData(res)));
  }

  updateProfileInfo(data: any, customHeaderValue?: any): Observable<any> {
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .patch(`${this.API_SERVER_SECURED}/user/personal-info`, data, { headers })
      .pipe(map((res: any) => this.extractData(res)));
  }

  updateProfileDesignation(data: any, customHeaderValue?: any): Observable<any> {
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .patch(`${this.API_SERVER_SECURED}/user/designation`, data, { headers })
      .pipe(map((res: any) => this.extractData(res)));
  }

  // share availability
  getUserAvailabilty(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/availability`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  updateUserAvailabilty(data: any, customHeaderValue?: any): Observable<any> {
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .patch(`${this.API_SERVER_SECURED}/user/availability`, data, { headers })
      .pipe(map((res: any) => this.extractData(res)));
  }

  getShareAvailabiltyLink(cParams = {}, customHeaderValue?: any): Observable<any> {
    const params  = this.getHttpParams(cParams);
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .get(`${this.API_SERVER_SECURED}/user/share-availability`, { headers, params })
      .pipe(map((res: any) => this.extractData(res)));
  }

  updateShareProfile(data: any, customHeaderValue?: any): Observable<any> {
    const headers = this.buildSpaceHeaders(customHeaderValue);
    return this.httpClient
      .patch(`${this.API_SERVER_SECURED}/user/share-availability`, data, { headers })
      .pipe(map((res: any) => this.extractData(res)));
  }

  switchCommunityToken(data: { user_id: number; space_id: number }): Observable<any> {
    return this.httpClient
      .post(`${this.API_SERVER_SECURED}/user/switch-community-token`, data)
      .pipe(map((res: any) => this.extractData(res)));
  }

  // ===================  Utils ===================

  private extractData(res: any): any {
    return res || {};
  }

  private getHttpParams(cParams: any): HttpParams {
    let params = new HttpParams();
    Object.keys(cParams || {}).forEach((k) => {
      params = params.set(k, cParams[k]);
    });
    return params;
  }

  /** Centralized header builder.
   * Precedence: explicit override → localStorage.spaceID → JWT → sessionStorage.pendingSpaceID.
   * NOTE: Interceptors already add spaceid; this is a safe belt-and-suspenders for legacy calls.
   */
  private buildSpaceHeaders(override?: any): HttpHeaders {
    let sid: string =
      (override != null && String(override)) ||
      localStorage.getItem('spaceID') ||
      '';

    if (!sid) {
      const maybe = this.auth.getSpaceIdFromToken();
      if (maybe) sid = String(maybe);
    }

    if (!sid) {
      const ss = sessionStorage.getItem('pendingSpaceID');
      if (ss) sid = ss;
    }

    return sid ? new HttpHeaders({ 'spaceID': sid }) : new HttpHeaders();
  }
}
